import { PropsWithChildren } from "react";

export function HeroTeaser({ children }: PropsWithChildren<{}>) {
  return (
    <div className="main-layout-centered min-h-screen py-10 bg-primary-50">
      {children}
    </div>
  );
}
